import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
/* istanbul ignore file */

export const getBulletinMessages = () =>
  axios.post('/infrastructure/notifications/getBulletinMessages', {}).then(({ data }) => data);

export const getLoginBulletinMessages = () =>
  axios.post('/branding/public/brand/getBulletinMessage', {}).then(({ data }) => data);

export const markBulletinAsRead = (bulletinId) =>
  axios
    .post('/infrastructure/notifications/markBulletinAsRead', {
      bulletinId
    })
    .then(({ data }) => data);

export function getMessageOfTheDay() {
  return from(axios.post('/infrastructure/notifications/getMessageOfTheDay', {})).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getMessage(service) {
  return from(axios.post('/branding/public/serviceMessage/getMessage', service)).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getActionItems() {
  return from(axios.post('/infrastructure/notifications/getActionItems')).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getUserActionItems() {
  return from(axios.post('/administration/user/getActionItems')).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getPaymentsActionItems() {
  return from(axios.post('/payments/notifications/getActionItems')).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getPassThroughActionItems() {
  return from(axios.post('/passthru/notifications/getActionItems')).pipe(
    map(({ data: { data } }) => ({
      data
    }))
  );
}

export function getServiceMessage(payload) {
  return from(axios.post('/infrastructure/notifications/getServiceMessage', payload)).pipe(
    map(({ data }) => data)
  );
}

export function getACHPPServiceMessage(service) {
  return from(axios.post('/branding/serviceMessage/getMessage', { service })).pipe(
    map(({ data: { data, success } }) => ({
      data,
      success
    }))
  );
}
